import { Dialog } from 'alurkerja-ui';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { MdCloudDownload } from 'react-icons/md';
import { downloadFile } from '@/utils/libs/fileUtil';
import { ResultService } from '@/api/result';

type ExportTestIssueProps = {
  id?: string;
  projectName?: string;
};

export const ExportResult: React.FC<ExportTestIssueProps> = ({
  id,
  projectName,
}) => {
  const { mutate: exportMutate, isPending: isExportLoading } =
    ResultService.useExport();
  const exportAction = (id: string) => {
    exportMutate(id, {
      onSuccess: response => {
        Dialog.success({
          title: 'Success',
          description: 'Result has been exported',
        });

        downloadFile(response, `TestResult_${projectName}.xlsx`);
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to export result',
        });
      },
    });
  };

  return (
    <OutlineButton
      icon={<MdCloudDownload />}
      onClick={() => exportAction(id!)}
      isLoading={isExportLoading}
    >
      Export
    </OutlineButton>
  );
};
